import mixpanel from "mixpanel-browser";

 mixpanel.init("12975c36bbee57606fd71911ea4a94fe", {
    track_pageview: true,
    persistence: "localStorage",
});

export { mixpanel };